var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.818,
    height: 16,
    viewBox: "0 0 13.818 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cadeado",
    transform: "translate(-2.5 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8499",
    "data-name": "Caminho 8499",
    d: "M14.893,6.818H14.5V6.091a5.091,5.091,0,1,0-10.182,0v.727H3.925A1.427,1.427,0,0,0,2.5,8.244v7.331A1.427,1.427,0,0,0,3.925,17H14.893a1.427,1.427,0,0,0,1.425-1.425V8.244a1.427,1.427,0,0,0-1.425-1.425ZM5.045,6.091a4.364,4.364,0,1,1,8.727,0v.727H12.318V6.091a2.909,2.909,0,1,0-5.818,0v.727H5.045Zm6.545.727H7.227V6.091a2.182,2.182,0,1,1,4.364,0Zm4,8.756a.691.691,0,0,1-.7.7H3.925a.691.691,0,0,1-.7-.7V8.244a.691.691,0,0,1,.7-.7H14.893a.691.691,0,0,1,.7.7Z",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8500",
    "data-name": "Caminho 8500",
    d: "M11.318,12a1.818,1.818,0,0,0-1.091,3.273v1.455a1.091,1.091,0,0,0,2.182,0V15.273A1.818,1.818,0,0,0,11.318,12Zm.544,2.764a.364.364,0,0,0-.18.314v1.649a.364.364,0,0,1-.727,0V15.076a.364.364,0,0,0-.18-.314,1.091,1.091,0,1,1,1.091,0Z",
    transform: "translate(-1.909 -3)",
    fill: "#38d2d9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.77842e3d5f7d2deaf54eb8923452a5a3.svg";
export { ForwardRef as ReactComponent };